import {Directive, Input, numberAttribute} from '@angular/core';
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors, Validators} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {debounceTime, first, map} from 'rxjs/operators';

/**
 * Validate email asynchronously.
 *
 * Usage: <input type="email" nlrEmail nlrEmailDebounceTime="number">
 *
 * Usage examples:
 *
 * 1. Validate email after default debounce time:
 *
 *    <input type="email" nlrEmail>
 *
 * 2. Validate email after custom debounce time:
 *
 *    <input type="email" nlrEmail nlrEmailDebounceTime="500">
 */
@Directive({
    selector: '[nlrEmail]',
    standalone: true,
    providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: NlrEmailDirective, multi: true}]
})
export class NlrEmailDirective implements AsyncValidator {
    @Input({transform: numberAttribute})
    nlrEmailDebounceTime: number = 750;

    constructor() {}

    validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        // When valid, return immediately
        if (Validators.email(control) === null) {
            return of(null);
        }

        // When invalid, validate again after debounce time has elapsed
        return control.valueChanges.pipe(
            debounceTime(this.nlrEmailDebounceTime),
            map(() => (Validators.email(control) ? {nlrEmail: true} : null)),
            first()
        );
    }
}
